import React from 'react';
import { UseComboboxReturnValue } from 'downshift';
import { Client } from '../../../../api/useSearchClientsQuery';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { ListItem } from './Clients.styles';
import { ClientsLoading } from './Clients.loading';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { ClientLozenge } from '../../../ClientLozenge/ClientLozenge';

interface ClientsProps {
  clients?: Client[];
  isLoading: boolean;
  comboboxBag: UseComboboxReturnValue<Client>;
}

export const Clients: React.FC<ClientsProps> = ({
  isLoading,
  clients,
  comboboxBag: { getItemProps, highlightedIndex },
}) => {
  if (isLoading) {
    return (
      <Box px="16" py={6}>
        <ClientsLoading />
      </Box>
    );
  }

  if (!clients) {
    return null;
  }

  if (clients.length === 0) {
    return (
      <ListItem>
        <Text fontWeight={500} color="neutral.500">
          No clients found
        </Text>
      </ListItem>
    );
  }

  return (
    <>
      {clients.map((client, index) => (
        <ListItem
          isClickable
          key={client.ConsumerId}
          {...getItemProps({ item: client, index })}
          isHighlighted={highlightedIndex === index}
        >
          <Box flex={1}>
            <Text as="span" fontWeight={500}>{`${client.FirstName} ${client.LastName}`}</Text>
            <Text as="span"> • {client.DisplayableConsumerId}</Text>
            <Text as="span"> • {client.OrganizationName}</Text>
          </Box>

          <ClientLozenge clientType={client.Type} />
        </ListItem>
      ))}
    </>
  );
};
